import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Calendar, ClipboardList, Mail, ArrowRight } from 'lucide-react'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_FORM_MODULES } from '../../../constants/adminModules'
import Card from '../../../components/ui/Card'

const ICONS = {
  clipboard: ClipboardList,
  calendar: Calendar,
  mail: Mail,
}

export default function AdminFormsIndex() {
  const { t } = useTranslation()
  const { hasModuleAccess } = useAuth()

  const visibleModules = ADMIN_FORM_MODULES.filter(({ key }) => hasModuleAccess(key))

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {visibleModules.map(({ key, route, labelKey, descriptionKey, icon }) => {
        const Icon = ICONS[icon] || ClipboardList

        return (
          <Link key={key} to={`/cp-login/forms/${route}`} className="group block h-full">
            <Card className="flex h-full flex-col transition-shadow group-hover:shadow-md">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <Icon className="h-6 w-6" />
              </div>
              <h2 className="mb-2 text-lg font-semibold text-primary">{t(labelKey)}</h2>
              <p className="mb-4 flex-1 text-sm text-text/60">{t(descriptionKey)}</p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-accent group-hover:gap-2">
                {t('admin.forms.openForm')}
                <ArrowRight className="h-4 w-4" />
              </span>
            </Card>
          </Link>
        )
      })}
    </div>
  )
}
